import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLanguage } from '../context/LanguageContext'
import { T } from './Translation'
import '../styles/Header.css'
import ukFlag from '../assets/flag-uk.svg'
import ilFlag from '../assets/flag-il.svg'
import iconLogo from '../assets/logo.webp'

function Header() {
  const navigate = useNavigate()
  const { language, toggleLanguage } = useLanguage()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const headerRef = useRef(null)

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20)
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false)
      }
    }

    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isMobileMenuOpen])

  // Function to handle anchor navigation with smooth scrolling
  const scrollToSection = (sectionId) => {
    // First change the URL to include the hash
    navigate(`/#${sectionId}`)

    // Then scroll to the element
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
    
    // Close mobile menu after navigation
    setIsMobileMenuOpen(false)
  }

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  return (
    <header className={`header-container${isScrolled ? ' scrolled' : ''}`} ref={headerRef}>
      <div className="header-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
        <img src={iconLogo} alt="Invitly Logo" className="logo-icon" />
        <span>Invitly</span>
      </div>
      
      {/* Hamburger menu button for mobile */}
      <button 
        className={`hamburger-menu ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={toggleMobileMenu}
        aria-label="Toggle navigation menu"
      >
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </button>
      
      <nav className={`header-nav ${isMobileMenuOpen ? 'mobile-nav-open' : ''}`}>
        {/* Replace Link components with buttons that call scrollToSection */}
        <button onClick={() => scrollToSection('hero')} className="nav-link">
          <T k="home" />
        </button>
        <button
          onClick={() => scrollToSection('services')}
          className="nav-link"
        >
          <T k="services" />
        </button>
        <button
          onClick={() => scrollToSection('testimonials')}
          className="nav-link"
        >
          <T k="testimonials" />
        </button>
        <button onClick={() => scrollToSection('pricing')} className="nav-link">
          <T k="pricing" />
        </button>
        <button onClick={() => scrollToSection('faq')} className="nav-link">
          <T k="faq" />
        </button>
        <button onClick={() => scrollToSection('contact')} className="nav-link">
          <T k="contactUs" />
        </button>
        {/* <button onClick={() => scrollToSection('join')} className="nav-link">
          <T k="joinButton" />
        </button> */}
        <div className="mobile-action-row">
          <a href="https://home.invitly.org" className="nav-link personal-area-link" target="_blank" rel="noopener noreferrer">
            <svg className="personal-area-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="8" r="4" />
              <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
            </svg>
            <T k="personalArea" />
          </a>
          {/* Language toggle button */}
          <button onClick={toggleLanguage} className="nav-link language-toggle">
            <img
              src={language === 'en' ? ilFlag : ukFlag}
              alt={language === 'en' ? 'Hebrew Flag' : 'English Flag'}
              className="flag-icon"
            />
            <span className="language-text">
              {language === 'en' ? 'עברית' : 'English'}
            </span>
          </button>
        </div>
      </nav>
    </header>
  )
}

export default Header
